import { useEffect } from "react";
import { GOOGLE_ANALYTICS_ID } from "../../../config";
import useGaTracker from "../../../hooks/useGaTracker";
import { setLastRefresh } from "../../../utils/clientVersionCookie";
import { setDeviceFingerprint } from "../../../utils/deviceFingerprint";
import { useAmpliSetup } from "../../analytics/use-ampli";
import { useAuth } from "../AuthContext";
import { useGetIdentityQuery } from "../queries/auth.graphql.generated";
import { identityVar, initVar, isEmbedVar } from "../vars";
import { useSignOut } from "./useSignOut";
export const useBootstrap = () => {
    const { authenticated } = useAuth();
    const { data: identityData, loading: identityLoading, refetch, } = useGetIdentityQuery();
    const { startGoogleAnalytics } = useGaTracker(GOOGLE_ANALYTICS_ID !== null && GOOGLE_ANALYTICS_ID !== void 0 ? GOOGLE_ANALYTICS_ID : "");
    useAmpliSetup();
    useEffect(() => {
        startGoogleAnalytics();
        setDeviceFingerprint();
        // track the last time we fetched the static `main.js` bundled file
        // so we can force refresh of cached browser client code
        setLastRefresh();
    }, []);
    useEffect(() => {
        if (authenticated)
            refetch();
    }, [authenticated]);
    // Handle Anonymous logic.
    useEffect(() => {
        if (identityLoading) {
            return;
        }
        if (!identityData) {
            console.error("identityData didn't load");
            return;
        }
        identityVar(identityData.identity);
        initVar(true);
    }, [identityData, identityLoading]);
    const signOut = useSignOut();
    useEffect(() => {
        var _a, _b;
        (_b = (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.on) === null || _b === void 0 ? void 0 : _b.call(_a, "accountsChanged", signOut);
        return () => {
            var _a, _b;
            (_b = (_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.removeListener) === null || _b === void 0 ? void 0 : _b.call(_a, "accountsChanged", signOut);
        };
    }, []);
    return {};
};
export const useEmbedBootstrap = () => {
    const { data: identityData, loading: identityLoading } = useGetIdentityQuery();
    useAmpliSetup();
    isEmbedVar(true);
    useEffect(() => {
        if (identityLoading) {
            return;
        }
        if (!identityData) {
            console.error("identityData didn't load");
            return;
        }
        identityVar(identityData.identity);
        // TODO: ampl identify
        initVar(true);
    }, [identityData, identityLoading]);
};
export const useNextBootstrap = () => {
    const { data: identityData, loading: identityLoading } = useGetIdentityQuery();
    useEffect(() => {
        setDeviceFingerprint();
    }, []);
    useAmpliSetup();
    // init amplitude
    // Handle Anonymous logic.
    useEffect(() => {
        if (identityLoading) {
            return;
        }
        if (!identityData) {
            console.error("identityData didn't load");
            return;
        }
        identityVar(identityData.identity);
        initVar(true);
    }, [identityData, identityLoading]);
    return {};
};
